import React from 'react'

const UiBox = (props) => {
    return (
        <>
            <div className="col-md-4">
            <div className="custom-box mt-5  p-3 rounded seo-box project">
               {props.font}
                <h3>{props.head}</h3>
                <p className="text-justify">{props.para}</p>
</div>
            </div>
        </>
    )
}

export default UiBox
